<script setup lang="ts">
import type { ShortcutJs } from "@/generated/models";
import { LinkIcon } from "lucide-vue-next";
import { useBookmarkMetadata } from "../bookmark/useBookmarkUrl";
import FileIconFromMetadata from "./FileIconFromMetadata.vue";

const props = defineProps<
  {
    file: ShortcutJs;
    shortcut?: never;
  } | {
    file?: never;
    shortcut: string;
  }
>();

const { metadata } = useBookmarkMetadata(() => props.file ?? props.shortcut);
</script>

<template>
  <FileIconFromMetadata v-if="metadata" :metadata="metadata" />
  <LinkIcon v-else aria-hidden="true" />
</template>
